import styled, { css } from "styled-components";
import { colors } from "globalStyles";
import InputRPS from "./InputRPS";
import { media } from "utils/style-utils";

export const Wrapper = styled.div`
  position: relative;
  margin: 0 0 4px;
  .drop-down-arrow {
    position: absolute;
    right: 20px;
    top: 50%;
    margin-top: -2px;
  }

  .tooltip {
    position: absolute;
    top: 16px;
    right: -40px;
  }
`;

export const Label = styled.label`
  display: inline-block;
  text-transform: uppercase;
  position: absolute;
  padding: 0 6px;
  margin: ${({ marginTop, marginLeft }) => `
    ${marginTop || -54}px ${marginLeft || 10}px;
  `}

  font-size: 8px;
  font-weight: 900;
  line-height: 13px;
  letter-spacing: 2px;
  color: ${colors.MENU_LINK};
  background-color: ${colors.WHITE};

  &:before {
    border-top: 1px solid ${({ labelBackgroundColor }) =>
      labelBackgroundColor || colors.WHITE};
    content:"";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    z-index: -1;
  }

  &.focused {
      color: ${colors.MAIN_COLOR};
  }

  &.multi-select {
    margin: ${({ marginTop, marginLeft }) => `
      ${marginTop || -6}px ${marginLeft || 10}px;
    `}
    top: 0;
  }
`;

export const LargeLabel = styled.label`
  height: 24px;
  color: ${colors.DARK};
  font-family: Poppins;
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
  display: block;
  margin-bottom: ${({ marginBottom }) => marginBottom || 0}px;
  margin-top: ${({ marginTop }) => marginTop || 0}px;
  margin-left: ${({ marginLeft }) => marginLeft || 0}px;
  ${({ bigCenter }) =>
    bigCenter &&
    `
    width: 100%;
    text-align: center;
    margin-right: 0px;
    `}
`;

export const DescriptionLabel = styled.label`
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  color: ${colors.BODY};
  font-weight: normal;
`;

export const LabelButton = styled.label`
  font-weight: bold;
  font-style: normal;
  font-size: 10px;
  cursor: pointer;
  text-align: center;
  padding: 8px 0;
  display: inline-block;
  width: 100%;
  height: 30px;
  background-color: ${colors.LIGHT_GRAY};
  border-radius: 3px;
  line-height: 14px;
  color: ${colors.MEDIUM_GRAY};
`;

export const EditBtn = styled.p`
  color: #183748;
  position: absolute;
  top: 19px;
  right: 20px;
  cursor: pointer;
  margin: 0px;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 2px;
  line-height: 13px;

  span {
    ${media.mobile`
    display: none;
  `}
  }
`;

export const InPlaceButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 23px;
  ${media.mobile`
      flex-direction: column-reverse;
      justify-content: flex-start;
  `}
`;

export const InPlaceBtn = styled.div`
  width: 237px;
  border-radius: 3px;
  padding: 16px 0px;
  color: #ffffff;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2px;
  text-align: center;
  cursor: pointer;
  text-transform: uppercase;

  span:nth-of-type(1) {
    display: block;
  }

  span:nth-of-type(2) {
    display: none;
  }

  ${media.mobile`
    width: 100%;

    span:first-child {
      display: none;
    }
    span:last-child {
      display: block;
    }
  `}

  &.cancel {
    border: 1px solid #ff3d00;
    color: #ff3d00;
  }

  &.submit {
    background-color: #00b0ff;
    ${media.mobile`
      margin-bottom: 10px;
    `}
  }
`;

export const ColorOpenerWrapper = styled.button`
  position: absolute;
  right: 20px;
  top: 0px;
  bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: none;
  border: 0;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  .drop-down-arrow {
    position: relative;
  }

  &.left {
    left: 18px;
    right: auto;
  }

  &:focus-visible {
    outline: 2px solid ${colors.MAIN_COLOR};
    outline-offset: 2px;
  }
`;

export const ColorContainer = styled.div`
  float: right;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  border-radius: 3px !important;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const OrText = styled.p`
  line-height: 0;
`;

export const ButtonGroup = styled.div`
  ${({ hasButtonText }) =>(
    hasButtonText &&
    `
      text-align: center;
      font-size: 11px;
      font-style: italic;
      font-weight: normal;
      line-height: 16px;
      padding-top: 12px;
    `)}
`;

export const PasswordButton = styled.button`
  position: absolute;
  font-size: 10px;
  text-align: right;
  line-height: 12px;
  margin: -30px -44px;
`;

export const RightIcon = styled.button`
  position: absolute;
  font-size: 10px;
  text-align: right;
  line-height: 12px;
  margin: -30px -24px;
`;

const inputStyles = css`
  display: block;
  width: 100%;
  border: 1px solid ${colors.LIGHT_GRAY};
  border-radius: 3px;
  font-size: 12px;
  font-family: neue-haas-unica, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.MENU};
  padding: 0 16px;
  -webkit-appearance: none;

  &::placeholder {
    color: ${colors.MENU_LINK};
  }

  &:focus {
    border: 1px solid ${colors.MAIN_COLOR};
    outline: none;
    box-shadow: 0px 8px 15px 0px ${colors.LIGHT_GRAY};
  }

  &:focus + label {
    color: ${colors.MAIN_COLOR};
  }
`;

export const StyledSecondButton = styled.button`
  ${inputStyles}
  height: 47px;
  font-weight: 300;
  text-align: left;
  text-transform: uppercase;
`;

export const SecondButtonText = styled.p`
  line-height: 0;
  padding-left: 10px;
`;

export const Input = styled.input`
  ${inputStyles}
  height: 47px;
  font-weight: normal;

  &.has-icon {
    padding: 0 40px 0 42px;
  }

  &.multi-select {
    border-radius: 0 0 3px 3px;
  }

  ${({ hasError }) =>
    hasError &&
    `
      border: 1px solid ${colors.RED};

      + label {
        color: ${colors.RED};
      }
    `}

  &.inPlace {
    border: 0px;
  }
`;

export const StyledRPS = styled(InputRPS)`
  &.CustomInput {
    & + label {
      margin-top: -87px;
    }
    & ~ button {
      top: 18px;
      right: 16px;
      margin: 0;
    }
  }
  ${inputStyles}

  padding: 0;

  .ReactPasswordStrength-strength-wrapper {
    margin-top: 10px;
    border: solid 1px ${colors.LIGHT_GRAY};
  }
  .ReactPasswordStrength-strength-desc {
    font-size: 1rem;
    font-weight: 400;
    /* right: 20px; */
    top: 2px;
    width: 95%;
    font-style: normal;
  }
  &.ReactPasswordStrength.is-strength-0 .ReactPasswordStrength-strength-bar {
    background: #ff0030;
  }
  &.ReactPasswordStrength.is-strength-1 .ReactPasswordStrength-strength-bar {
    background: rgb(255, 0, 0);
    background: linear-gradient(
      90deg,
      rgba(255, 0, 0, 1) 0%,
      rgba(192, 0, 255, 1) 100%
    );
  }
  &.ReactPasswordStrength.is-strength-2 .ReactPasswordStrength-strength-bar {
    background: rgb(255, 0, 0);
    background: linear-gradient(
      90deg,
      rgba(255, 0, 0, 1) 0%,
      rgba(192, 0, 255, 1) 50%,
      rgba(0, 61, 255, 1) 100%
    );
  }
  &.ReactPasswordStrength.is-strength-3 .ReactPasswordStrength-strength-bar {
    background: rgb(255, 0, 0);
    background: linear-gradient(
      90deg,
      rgba(255, 0, 0, 1) 0%,
      rgba(192, 0, 255, 1) 36%,
      rgba(0, 61, 255, 1) 71%,
      rgba(139, 255, 178, 1) 100%
    );
  }
  &.ReactPasswordStrength.is-strength-4 .ReactPasswordStrength-strength-bar {
    background: rgb(255, 0, 0);
    background: linear-gradient(
      90deg,
      rgba(255, 0, 0, 1) 0%,
      rgba(192, 0, 255, 1) 28%,
      rgba(0, 61, 255, 1) 56%,
      rgba(52, 246, 117, 1) 84%
    );
  }
  & .ReactPasswordStrength-strength-bar {
    // top: 10px;
    height: 3px;
  }

  &:focus-within {
    box-shadow: 0px 8px 15px 0px ${colors.LIGHT_GRAY};
  }

  &:focus {
    border: none;
  }

  &:focus-within + label {
    color: ${colors.MAIN_COLOR};
  }

  ${({ hasError }) => {
    return (
      hasError &&
      `

      + label {
        color: ${colors.RED};
      }
    `
    );
  }}
`;

export const UnstyledInput = styled.input``;

export const FileWrapper = styled.div`
  background: transparent;

  ${({ height }) =>
    height &&
    `
    height: ${height}px;
  `}
`;

export const Options = styled.div`
  width: 100%;
  max-height: 160px;
  background-color: ${colors.WHITE};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid ${colors.LIGHT_GRAY};
  z-index: 99;
  position: absolute;
  font-size: 12px;
  font-weight: normal;
  line-height: 18px;
  color: ${colors.MENU_LINK};
  overflow: auto;
  z-index: 10000;

  &.flex-display {
    display: flex;
  }
`;

export const Option = styled.div`
  padding: 10px 20px;
  cursor: pointer;

  ${({ selected }) => selected && `background-color: ${colors.LIGHT_BLUE};`}
  /* Keyboard-active row (aria-activedescendant target); wins over selected. */
  ${({ $active }) => $active && `background-color: ${colors.LIGHT_GRAY};`}
`;

export const SelectIcon = styled.div`
  position: absolute;
  z-index: 1;
  margin: -32px 18px;

  &.right {
    right: 0;
    margin: -35px 18px;
    cursor: pointer;
  }

  /* The clear control is keyboard-focusable (role="button"), and the global
     stylesheet strips the UA outline — give it its own visible ring. */
  &:focus-visible {
    outline: 2px solid ${colors.MAIN_COLOR};
    outline-offset: 2px;
  }
`;

export const TextArea = styled.textarea`
  ${inputStyles}
  padding: 10px 16px;
  height: 102px;
  font-weight: normal;

  &::placeholder {
    color: ${colors.MENU_LINK};
  }

  &:focus {
    border: 1px solid ${colors.MAIN_COLOR};
    outline: none;
  }

  &:focus + label {
    color: ${colors.MENU_LINK};
  }

  &.has-icon {
    padding: 0 42px;
  }

  &.multi-select {
    border-radius: 0 0 3px 3px;
  }

  ${({ hasError }) =>
    hasError &&
    `
      border: 1px solid ${colors.RED};

      + label {
        color: ${colors.RED};
      }
    `}

  &.inPlace {
    border: 0px;
  }
`;
